import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=92f4a624"
import script from "./Scores.vue?vue&type=script&lang=js"
export * from "./Scores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports